import { render, staticRenderFns } from "./SelectSounds.vue?vue&type=template&id=133af560&"
import script from "./SelectSounds.vue?vue&type=script&lang=js&"
export * from "./SelectSounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports